"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RenderIf;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function RenderIf(_ref) {
  var isTrue = _ref.isTrue,
      children = _ref.children;

  if (isTrue) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }

  return null;
}

RenderIf.propTypes = {
  /** Indicates whether the component content is showed or not. If is set to true, then is showed the component content. */
  isTrue: _propTypes["default"].any,

  /** The content of the component. */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object])
};
RenderIf.defaultProps = {
  isTrue: false,
  children: []
};